import type { UnitListFilters } from "~/types/unit";

/** Encodes multiple location terms for the listing-list API query param. */
export const LISTING_LOCATION_API_SEPARATOR = "|";

export function normalizeLocationTerms(terms: string[]): string[] {
  const seen = new Set<string>();
  const normalized: string[] = [];
  for (const term of terms) {
    const trimmed = term.trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    normalized.push(trimmed);
  }
  return normalized;
}

export function parseLocationsFromSearchParams(
  searchParams: URLSearchParams
): string[] {
  return normalizeLocationTerms(searchParams.getAll("location"));
}

export function encodeLocationsForApi(locations: string[]): string | undefined {
  const normalized = normalizeLocationTerms(locations);
  if (normalized.length === 0) return undefined;
  return normalized.join(LISTING_LOCATION_API_SEPARATOR);
}

export function getFilterLocations(filters: UnitListFilters): string[] {
  if (filters.locations?.length) {
    return normalizeLocationTerms(filters.locations);
  }
  if (filters.location?.trim()) {
    return [filters.location.trim()];
  }
  return [];
}

export function appendPendingLocationTerm(
  current: string[],
  pendingInput: string
): string[] {
  const pending = pendingInput.trim();
  if (!pending) return normalizeLocationTerms(current);
  return normalizeLocationTerms([...current, pending]);
}

export function withFilterLocations(
  filters: UnitListFilters,
  locations: string[]
): UnitListFilters {
  const next = { ...filters };
  delete next.location;
  const normalized = normalizeLocationTerms(locations);
  if (normalized.length > 0) {
    next.locations = normalized;
  } else {
    delete next.locations;
  }
  return next;
}
